//@flow
import React, { Component } from "react";
import { KeyboardAvoidingView, Platform } from "react-native";
import { HeaderHeightContext } from "@react-navigation/elements";
import { connect } from "react-redux";
import { submitAnswersRequest } from "@microdoing/shared/services/survey/actions";
import i18n from "@microdoing/shared/i18n";
import { getUserId } from "@microdoing/shared/services/user/selectors";
import getRandomIntInclusive from "../../utils/getRandomIntInclusive";
import selectLanguage from "../../utils/selectLanguage";
import { getCampaignId } from "@microdoing/shared/services/userCampaign/selectors";
import { getSurveyId } from "@microdoing/shared/services/survey/selectors";
import { getLanguage } from "@microdoing/shared/services/profileSettings/selectors";
import SignupBottom from "../Signup/SignupBottom";
import Slides from "./Slides";
import { Box, MainText } from "app/components/common";
import theme from "app/Theme/Theme";
import SignupHeader from "../Signup/SignupHeader";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import WebSurvey from "./WebSurvey";
import { SafeAreaView } from "react-native-safe-area-context";

const ConfidenceImage = require("../../../assets/images/confidence.png");
const TeamImage = require("../../../assets/images/team.png");
const SpeakingImage = require("../../../assets/images/team.png"); // TODO need the new speaking image
const StressImage = require("../../../assets/images/stress.png");
const PeaceImage = require("../../../assets/images/peace.png"); // TODO need the new peace image
const BriefingImage = require("../../../assets/images/briefing.png"); // TODO need the new briefing image
const CapitalizationImage = require("../../../assets/images/capitalization.png"); // TODO need the new capitalization image
const DebriefingImage = require("../../../assets/images/debriefing.png"); // TODO need the new debriefing image
const IntegrationImage = require("../../../assets/images/integration.png"); // TODO need the new integration image
const LeadershipImage = require("../../../assets/images/leadership.png"); // TODO need the new leadership image
const MotivationImage = require("../../../assets/images/motivation.png"); // TODO need the new motivation image
const PositionImage = require("../../../assets/images/position.png"); // TODO need the new position image
const PreparationImage = require("../../../assets/images/preparation.png"); // TODO need the new preparation image
const RecruitingImage = require("../../../assets/images/recruiting.png"); // TODO need the new recruiting image
const TrainingImage = require("../../../assets/images/training.png"); // TODO need the new training image
const VisualizationImage = require("../../../assets/images/visualization.png"); // TODO need the new visualization image
const TeamCohesion = require("../../../assets/images/teamCohesion.png");

const allImages = [
  ConfidenceImage,
  TeamImage,
  SpeakingImage,
  StressImage,
  PeaceImage,
  BriefingImage,
  CapitalizationImage,
  DebriefingImage,
  IntegrationImage,
  LeadershipImage,
  MotivationImage,
  PositionImage,
  PreparationImage,
  RecruitingImage,
  TrainingImage,
  VisualizationImage,
  TeamCohesion,
];

const initializeAnswers = (questions, answers = []) => {
  return questions.map((question, index) => {
    const questionId = question._id;
    const existingAnswer = answers?.find(el => el.questionId === questionId);
    return {
      choices: [],
      questionId: question._id,
      value: 5,
      ...existingAnswer,
    };
  });
};

class Survey extends Component {
  constructor(props) {
    super(props);
    this.state = {
      questionIndex: 0,
      answers: initializeAnswers(this.props.questions, this.props.answers),
    };
  }

  static getDerivedStateFromProps(props, current_state) {
    if (current_state.answers.length !== props.questions.length) {
      return {
        questionIndex: 0,
        answers: initializeAnswers(props.questions, props.answers),
      };
    }
    return null;
  }

  goNext = () => {
    this.setState({ questionIndex: this.state.questionIndex + 1 });
  };

  goBack = () => {
    if (this.state.questionIndex === 0) {
      return this.props.navigation.goBack();
    }
    this.setState({ questionIndex: this.state.questionIndex - 1 });
  };

  onRemoveChoice = choice => () => {
    const { answers, questionIndex } = this.state;

    const newAnswers = answers.map((answer, index) => {
      if (index === questionIndex) {
        const choices = [...answer.choices, choice];
        return { ...answer, choices };
      }
      return answer;
    });
    this.setState({ answers: newAnswers });
  };

  onAddChoice = choice => () => {
    const { answers, questionIndex, language } = this.state;

    const newAnswers = answers.map((answer, index) => {
      if (index === questionIndex) {
        const choiceTitle = selectLanguage({ text: choice, language });
        const isSelectedIndex = answer.choices.findIndex(
          el => selectLanguage({ text: el, language }) === choiceTitle,
        );

        // remove
        if (isSelectedIndex > -1) {
          const choices = answer.choices.filter(
            (el, choiceIndex) => choiceIndex !== isSelectedIndex,
          );
          return { ...answer, choices };
        } else {
          // add
          const choices = [...answer.choices, choice];

          return { ...answer, choices };
        }
      }

      return answer;
    });
    this.setState({ answers: newAnswers });
  };

  onValueChange = value => {
    const { answers, questionIndex } = this.state;

    const newAnswers = answers.map((answer, index) => {
      if (index === questionIndex) {
        return { ...answer, value };
      }
      return answer;
    });
    this.setState({ answers: newAnswers });
  };

  generateCustomSlides = answers => {
    const { questions, language } = this.props;

    const slides = questions.map((question, index) => {
      const {
        questionTitle,
        leftLabel,
        rightLabel,
        questionType,
        scale,
      } = question;
      const image =
        index < allImages.length
          ? allImages[index]
          : allImages[getRandomIntInclusive(0, allImages.length - 1)];

      const value = answers[index].value;

      const leftLabelText = selectLanguage({ text: leftLabel, language });
      const rightLabelText = selectLanguage({ text: rightLabel, language });

      return {
        value,
        title: selectLanguage({ text: questionTitle, language }),
        secondTitle: "",
        image,
        leftLabel: leftLabelText,
        rightLabel: rightLabelText,
        questionType,
        options: question.choices,
        choices: answers[index].choices,
        scale,
      };
    });
    return slides;
  };

  submit = () => {
    const { userId, campaignId, surveyId, isComingFromSignup } = this.props;
    const { answers } = this.state;

    if (!surveyId) {
      return this.props.navigation.replace("Main");
    }

    this.props.submitAnswersRequest({
      userId,
      campaignId,
      surveyId,
      answers,
      isComingFromSignup,
    });
  };

  onPressExit = () => {
    this.props.navigation.replace("Main");
  };

  render() {
    const { questions, answers = [], isComingFromSignup } = this.props;
    const isLastSlide =
      this.state.questionIndex === this.props.questions?.length - 1;
    const isFirstSlide = this.state.questionIndex === 0;

    if (isWebDesktop) {
      return (
        <WebSurvey
          answers={this.state.answers}
          questionIndex={this.state.questionIndex}
          isLastSlide={isLastSlide}
          requesting={this.props.requesting}
          isComingFromSignup={isComingFromSignup}
          onValueChange={this.onValueChange}
          onAddChoice={this.onAddChoice}
          generateCustomSlides={this.generateCustomSlides}
          goBack={this.goBack}
          goNext={this.goNext}
          submit={this.submit}
        />
      );
    }

    return (
      <Box variant="screenView" backgroundColor="neutral.white">
        <SafeAreaView style={{ flex: 1 }}>
          <Box
            flexDirection="column"
            justifyContent="flex-start"
            alignItems="center"
          >
            <SignupHeader
              onPressExit={isComingFromSignup ? false : this.onPressExit}
              progress={
                !questions.length
                  ? 0
                  : this.state.questionIndex / questions.length
              }
            />
            {!!answers?.length && (
              <MainText variant="l3-medium" color="brand.500">
                {i18n.t("survey-already-answered")}
              </MainText>
            )}
          </Box>
          <Box flex={1} marginVertical="m">
            {this.generateCustomSlides(this.state.answers).map(
              (slide, index) => {
                if (index === this.state.questionIndex) {
                  return (
                    <Slides
                      {...slide}
                      key={index}
                      onPressChoice={this.onAddChoice}
                      onValueChange={this.onValueChange}
                    />
                  );
                }
                return null;
              },
            )}
          </Box>
          <HeaderHeightContext.Consumer>
            {headerHeight => (
              <KeyboardAvoidingView
                {...(Platform.OS === "ios" ? { behavior: "padding" } : {})}
                keyboardVerticalOffset={headerHeight + 44}
              >
                <SignupBottom
                  rightButtonText={
                    isLastSlide
                      ? i18n.t("submit")
                      : i18n.t("signup-next-button")
                  }
                  isRequesting={this.props.requesting}
                  isRightButtonLocked={this.props.requesting}
                  noLeftButton={
                    isComingFromSignup ? false : this.state.questionIndex === 0
                  }
                  onPressBack={this.goBack}
                  onPressNext={isLastSlide ? this.submit : this.goNext}
                />
              </KeyboardAvoidingView>
            )}
          </HeaderHeightContext.Consumer>
        </SafeAreaView>
      </Box>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { requesting, survey } = state.survey;
  const { questions, answers = [] } = survey;

  const isComingFromSignup = ownProps?.route?.params?.isComingFromSignup;

  return {
    userId: getUserId(state),
    campaignId: getCampaignId(state),
    surveyId: getSurveyId(state),
    language: getLanguage(state),
    isComingFromSignup,
    answers,
    questions,
    requesting,
  };
};

export default connect(mapStateToProps, {
  submitAnswersRequest,
})(Survey);
